/* Bundl'd Bunch theme interactions */
(function () {
  'use strict';

  /* ---- mobile menu ---- */
  window.toggleMobileMenu = function () {
    var m = document.getElementById('mobile-menu');
    if (m) m.classList.toggle('open');
  };

  /* ---- search toggle (small screens fall back to /search) ---- */
  window.toggleSearch = function () {
    var input = document.getElementById('search-input');
    if (!input) return;
    if (input.style.width === '0px' || !input.style.width) {
      input.style.width = '200px';
      input.style.opacity = '1';
      input.focus();
    } else {
      input.style.width = '0px';
      input.style.opacity = '0';
    }
  };

  /* ---- quantity stepper on product page ---- */
  window.changeQty = function (delta) {
    var input = document.getElementById('qty-input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + delta);
    input.value = v;
  };

  /* ---- product gallery thumbnails ---- */
  window.swapMainImage = function (src, el) {
    var main = document.getElementById('pd-main-img');
    if (main) main.src = src;
    document.querySelectorAll('.pd-thumb').forEach(function (t) { t.classList.remove('active'); });
    if (el) el.classList.add('active');
  };

  /* ---- cart count helper ---- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (b) {
          b.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  /* ---- AJAX add to cart on product form ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding… 🍬'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartCount();
        if (btn) { btn.innerHTML = 'Added! 🎉'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1400); }
      })
      .catch(function () {
        if (btn) { btn.innerHTML = label; btn.disabled = false; }
        window.location.href = '/cart';
      });
  });
})();
